import { render, staticRenderFns } from "./BtnGlosar.vue?vue&type=template&id=246006d2"
import script from "./BtnGlosar.vue?vue&type=script&lang=js"
export * from "./BtnGlosar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports